<template>
  <div>
    <div class="columns">
      <div v-if="this.url_moderateur" style="margin:20px auto;">
        <ExportCSVButton :url_moderateur="this.url_moderateur" />
      </div>
      <div style="margin:20px auto;">
        <ExportPDFButton
          :url_moderateur="url_moderateur"
          :insight_id="insight_id"
        />
      </div>
    </div>
  </div>
</template>

<script>
import ExportCSVButton from "@/components/insight/Buttons/ExportCSVButton";
import ExportPDFButton from "@/components/insight/Buttons/ExportPDFButton";
import { mapActions, mapMutations, mapGetters } from "vuex";

export default {
  components: {
    ExportCSVButton,
    ExportPDFButton,
  },
  props: {
    insight_id: Number,
    url_moderateur: String,
    rowIndex: Number,
    cardList: Boolean,
  },
  computed: {
    ...mapGetters(["modalExportExcelPdf"]),
  },
};
</script>

<style scoped>
.hide-element {
  position: absolute;
  height: auto;
  width: 1200px;
  right: 0;
  top: 0px;
  visibility: hidden;
}
</style>
